__turbopack_context__.v({
  "avatar": "CreatorCard-module___mwQhG__avatar",
  "profileDetails": "CreatorCard-module___mwQhG__profileDetails",
  "profileDetailsContainer": "CreatorCard-module___mwQhG__profileDetailsContainer",
});
